export default "__VITE_ASSET___rtIKKz___"